import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { CANADA_PROVINCE } from "@faire/web--source/common/consts/CANADA_PROVINCE";
import { CANADA_PROVINCE_SHORTHAND } from "@faire/web--source/common/consts/CANADA_PROVINCE_SHORTHAND";
import { STATE_PROVINCE_SHORTHAND_TO_NAME } from "@faire/web--source/common/consts/STATE_PROVINCE_SHORTHAND_TO_NAME";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { US_STATE } from "@faire/web--source/common/consts/US_STATE";
import { US_STATE_SHORTHAND } from "@faire/web--source/common/consts/US_STATE_SHORTHAND";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Input } from "@faire/web--source/slate/Input";
import { SearchDropdown } from "@faire/web--source/slate/Input/SearchDropdown";
import React from "react";
export var StateOrProvince = function(param) {
    var shouldRender = param.shouldRender, label = param.label, country = param.country, error = param.error, value = param.value, handleChange = param.handleChange, setFormValues = param.setFormValues, setFieldValue = param.setFieldValue, formValues = param.formValues;
    var strictLocalize = useStrictLocalization().strictLocalize;
    if (!shouldRender) {
        return null;
    }
    var hasStateOrProvince = [
        THREE_LETTER_PRIMARY_COUNTRY_CODES.USA,
        THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN
    ].includes(country);
    if (hasStateOrProvince) {
        var _STATE_PROVINCE_SHORTHAND_TO_NAME_value;
        return /*#__PURE__*/ _jsx(SearchDropdown, {
            label: label,
            "data-test-id": "state",
            name: "state",
            value: (_STATE_PROVINCE_SHORTHAND_TO_NAME_value = STATE_PROVINCE_SHORTHAND_TO_NAME(strictLocalize)[value]) !== null && _STATE_PROVINCE_SHORTHAND_TO_NAME_value !== void 0 ? _STATE_PROVINCE_SHORTHAND_TO_NAME_value : value,
            error: error,
            options: getStateOrProvince(country)(strictLocalize),
            alternativeOptions: getStateOrProvinceShorthand(country),
            onChange: handleChange,
            onSelect: function(stateOrProvince) {
                setFieldValue("state", stateOrProvince.value);
                setFormValues(_object_spread_props(_object_spread({}, formValues), {
                    state: stateOrProvince.value
                }));
            }
        });
    }
    return /*#__PURE__*/ _jsx(Input, {
        label: label,
        type: "text",
        name: "state",
        error: error,
        value: value,
        onChange: handleChange
    });
};
var getStateOrProvince = function(country) {
    switch(country){
        case THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN:
            return CANADA_PROVINCE;
        case THREE_LETTER_PRIMARY_COUNTRY_CODES.USA:
        default:
            return US_STATE;
    }
};
var getStateOrProvinceShorthand = function(country) {
    switch(country){
        case THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN:
            return CANADA_PROVINCE_SHORTHAND;
        case THREE_LETTER_PRIMARY_COUNTRY_CODES.USA:
        default:
            return US_STATE_SHORTHAND;
    }
};
